// NOTE: js-routes が生成する Routes オブジェクト（window.Routes）を読み込む
// lib/tasks/js_routes.rake の rake js_routes:generate で生成される
import "../../../assets/javascripts/lib/routes";
